export default __webpack_public_path__ + "static/media/illustration-canada.30bd3439.svg";